export enum GradeType {
  /** Barneskole 1-4 */
  Grade1To4 = 'grade1to4',

  /** Barneskole 5-7 */
  Grade5To7 = 'grade5to7',

  /** Ungdomskole 8-10 */
  Grade8To10 = 'grade8to10',

  /** Videregående vg1-vg3 */
  GradeVgs = 'gradeVgs',

  /** Voksenopplæring */
  GradeAdult = 'gradeAdult',

  /** Forkurs */
  GradePrep = 'gradePrep',
}

export const allGradeTypes: GradeType[] = Object.values(GradeType)
